import { NgModule } from '@angular/core';

import { CamelCaseToTextPipe } from './camel-case-to-text.pipe';

@NgModule({
  declarations: [
    CamelCaseToTextPipe,
  ],
  exports: [
    CamelCaseToTextPipe,
  ],
})
export class CamelCaseToTextPipeModule {
}
